module.exports = __webpack_public_path__ + "static/2-d4e82c3d0482d3dcec3a25aaa244a5c9.png";